<template>
    <div class="files-select">
        <button class="file-select-btn" @click="handleUploadFiles" title="选择文件">
            <i class="iconfont ai-fujiancopy"></i>
        </button>
        <input ref="fileInput" type="file" style="display: none" :accept="accept" :multiple="multiple" @change="handleFileChange">
    </div>
</template>

<script>
export default {
    name: 'files-select',
    props: {
        loadFiles: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            accept: 'image/*,video/*,audio/*,application/*,.txt,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx',
            multiple: true,
        };
    },
    methods: {
        handleFileChange(event) {
            const files = event.target.files;
            if (!files || files.length === 0) { return; }
            const fileList = [];
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                fileList.push({
                    uid: this.generateUUID(),
                    name: file.name,
                    fileSize: file.size,
                    imgFile: file,
                    url: URL.createObjectURL(file),
                });
            }

            this.loadFiles(fileList);

            // 重置文件选择器
            this.$nextTick(() => {
                event.target.value = '';
            });
        },

        handleUploadFiles() {
            this.$refs.fileInput.click();
        },

        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0;
                const v = c === 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        },
    },
};
</script>

<style scoped>
@import url('../../assets/fonts/iconfont/iconfont.css');

.files-select {
    display: inline-block;
}

.file-select-btn {
    color: #606266;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 20px;
    padding: 0 12px;
    height: 32px;
    cursor: pointer;
    font-size: 16px;
    transition: all 0.3s;
}

.file-select-btn:hover {
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
</style>
